import GeoJSON from 'ol/format/GeoJSON';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { Dropdown } from 'primereact/dropdown';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { RadioButton } from 'primereact/radiobutton';
import { useEffect, useRef, useState } from 'react'
import { setFitGeom, setHighlightAll, setHighlightGeom, setHighlightGeomForTransportation } from '../../features/mapSlice';
import { firmResult, setFirmResult } from '../../features/searchResultSlice';
import { setSelectedFeature } from '../../features/selectionSlice';
import { useAppDispatch, useAppSelector } from '../../store/hooks'
import OsbInfo from './OsbInfo';
import ParselInfo from './ParselInfo';
import TkgmParsel from './TkgmParsel/TkgmParsel';
import { Calendar } from 'primereact/calendar';
import WFS from 'ol/format/WFS';
import axios from 'axios';
import { Feature } from 'ol';
import { useTranslation } from 'react-i18next';
import { Toast } from 'primereact/toast';
import { setOsbler, setShowLoading } from '../../features/sharedSlice';
import { InputMask } from 'primereact/inputmask';

export default function InfoPanel() {
    const { t } = useTranslation();
    const toast = useRef<any>()
    const iller = useAppSelector(state => state.sharedState.iller)
    const ilceler = useAppSelector(state => state.sharedState.ilceler)
    const selectedFeature = useAppSelector(state => state.selectionState.selectedFeature);
    const firmProperties = useAppSelector(firmResult);
    const services = useAppSelector(state => state.layer.services);
    const show3d = useAppSelector(state => state.toolbarState.show3d);
    const token = useAppSelector(state => state.authState.token);
    const zoneRoles = useAppSelector(state => state.sharedState.zoneRoles);
    const [featureLayer, setFeatureLayer] = useState<any>();
    const [valuesForPlanlar, setValuesForPlanlar] = useState<any>();
    const [updateState, setUpdateState] = useState<any>();
    const [canUpdate, setCanUpdate] = useState<boolean>(false);
    const dispatch = useAppDispatch()
    const [copyProperties, setCopyProperties] = useState<any>();
    const [osbSayisi, setOsbSayisi] = useState<any>();
    let properties = selectedFeature?.properties;
    const [domain, setDomain] = useState<any>([])
    const [ebler, setEbler] = useState<any>([])
    const [tgbler, setTgbler] = useState<any>([])
    const [proceed, setProceed] = useState<any>(true)
    const [epostaError, setEpostaError] = useState<any>(false)
    const osbler = useAppSelector(state => state.sharedState.osbler);

    useEffect(() => {
        getOsbler()
        getEbler()
        getTgbler()
        getDomain()
    }, [])

    useEffect(() => {
        if (selectedFeature) {
            if (selectedFeature.id?.split('.')[0] === 'istatistik_bolge_duzey_2_usr') {
                getOsbSayisi('osbandistihdambyibbs2', properties.kodu)
            }
            if (selectedFeature.id?.split('.')[0] === 'cografi_bolge_usr') {
                getOsbSayisi('osbandistihdambycografi', properties.adi)
            }
            if (selectedFeature.id?.split('.')[0] === 'tesvik_bolgeleri_usr') {
                getOsbSayisi('osbandistihdambytesvik', properties.adi)
            }
        }

    }, [selectedFeature])

    const getOsbSayisi = async (key: string, value: any) => {
        const response = await axios(`${process.env.REACT_APP_BASE_URL}rest/v1/osb-rapor/${key}?token=${token}`)
        const osbInfo = response.data.data;
        const finded = osbInfo.find((osb: any) => osb.bolge === value)
        if (finded) {
            setOsbSayisi(finded.osb_sayisi);
        }
    }

    useEffect(() => {
        if (selectedFeature && selectedFeature.id) {
            // setFeatureLayer(null)

            setCopyProperties(properties);

            const layername = selectedFeature.id?.split('.')[0]

            if (layername) {
                const layer = services.find(service => { return service.layers.some(layer => layer.name === layername) })?.layers.find(layer => layer.name === layername)
                if (layer) {
                    const featureLayerClone = Object.assign({}, layer)

                    defineCanUpdate(featureLayerClone, properties.zone_id);
                    featureLayerClone.fields = featureLayerClone.fields.filter(obj => (obj.type !== 'Geom' && obj.type !== 'Id' && obj.type !== 'CreatedDate' && obj.type !== 'CreatedBy'
                        && obj.type !== 'TouchDate' && obj.type !== 'TouchBy' && obj.name !== 'osb_gid' && obj.name !== 'zone_id' && obj.name !== 'active'))
                    setFeatureLayer(featureLayerClone);

                    if (layername === 'ebler_usr') {
                        featureLayerClone.fields = featureLayerClone.fields.filter(obj => (obj.name !== 'fax' && obj.name !== 'sektor' && obj.name !== 'cumhurbask_karar_sayisi' && obj.name !== 'cumhurbask_karar_tarihi' && obj.name !== 'vergi_no' && obj.name !== 'durum'))
                        setFeatureLayer(featureLayerClone);
                    }
                    if (layername === 'tgb_usr') {
                        featureLayerClone.fields = featureLayerClone.fields.filter(obj => (obj.name !== 'yonetici_sirket'))
                        setFeatureLayer(featureLayerClone);
                    }

                    const geojson = new GeoJSON()
                    const olFeature :any = geojson.readFeature(selectedFeature)
                    let olGeom: any = olFeature.getGeometry();
                    if (layername === 'uip_1000' || layername === 'eb_uip_1000' || layername === 'tgb_uip_1000') {
                        olGeom = olGeom.getGeometries();
                        dispatch(setHighlightAll([selectedFeature]))
                        dispatch(setFitGeom(selectedFeature.geometry[0]))

                    }
                    else {

                        if (!show3d) {
                            dispatch(setFitGeom({ type: olGeom?.getType(), coordinates: (olGeom as any)?.getCoordinates() }))
                        }
                        dispatch(setHighlightGeom({ type: olGeom?.getType(), coordinates: (olGeom as any)?.getCoordinates() }))
                    }
                }
            }
            if (layername === 'uip_1000' || layername === 'eb_uip_1000' || layername === 'tgb_uip_1000') {
                const arr: any = [];
                for (const [key, value] of Object.entries(selectedFeature.properties) as any) {
                    if (key === 'onay_tarihi' || key === 'planadi' || key === 'buyukluk') {
                        arr.push({ key, value });
                    }
                    if (key === 'plan_niteligi') {
                        arr.push({ key, value: domain.find((dom: any) => dom.id === +value)?.desc });
                    }
                    if (key === 'osb') {
                        arr.push({ key, value: osbler.find((osb: any) => osb.id === +value)?.adi });
                    }
                    if (key === 'eb') {
                        arr.push({ key, value: ebler.find((osb: any) => osb.id === +value)?.adi });
                    }
                    if (key === 'tgb') {
                        arr.push({ key, value: tgbler.find((osb: any) => osb.id === +value)?.adi });
                    }
                }
                setTimeout(() => {
                    setValuesForPlanlar(arr);
                }, 100);

            }
        } else if (selectedFeature && selectedFeature.get && selectedFeature.get('tkgm')) {
            setFeatureLayer(null)

            const olGeom = selectedFeature.getGeometry();
            if (!show3d) {
                dispatch(setFitGeom({ type: olGeom?.getType(), coordinates: (olGeom as any)?.getCoordinates() }));
            }
            dispatch(setHighlightGeom({ type: olGeom?.getType(), coordinates: (olGeom as any)?.getCoordinates() }));
        } else if (firmProperties) {
            setFeatureLayer(null)

            properties = firmProperties
            setCopyProperties(properties);
        }
        else {
            setFeatureLayer(null)

            dispatch(setFitGeom(null));
            dispatch(setHighlightGeom(null));
            dispatch(setHighlightGeomForTransportation(null))
        }
    }, [selectedFeature, firmProperties, osbSayisi])

    const defineCanUpdate = (layer: any, zoneID: any) => {
        const hasZonePerm = zoneRoles.some(zoneObject => zoneObject.zone_id === zoneID && zoneObject.permission >= 3);
        if (layer.perm >= 3 && hasZonePerm) {
            setCanUpdate(true);
        } else {
            setCanUpdate(false);
        }
    }
    const changeValue = (value: any, name: string) => {
        if (name === "eposta" && value) {
            if (name === "eposta" && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
                setProceed(true)
                setEpostaError(false);
            } else if (name === "eposta" && !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
                setProceed(false)
                setEpostaError(true);
            }
            else {
                setProceed(true)
            }
        }
        if (name === "eposta" && !value) {
            setProceed(true)
            setEpostaError(false);
        }

        setCopyProperties({
            ...copyProperties,
            [name]: value
        });
    }
    
    const getOsbler = async () => {
        const serviceUrl = services.filter(obj => obj.type === 'VECTOR')[0]?.url
        if (serviceUrl) {
            const response = await axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature` + (token ? `&token=${token}` : '') + `&outputFormat=application/json&typeName=osb_sinir_usr&propertyname=adi,id`)
            const osbValues = response.data.features.map(((value: any) => value.properties))
            dispatch(setOsbler(osbValues))
        }
    }
    const getEbler = async () => {
        const serviceUrl = services.filter(obj => obj.type === 'VECTOR')[0]?.url
        if (serviceUrl) {
            const response = await axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature` + (token ? `&token=${token}` : '') + `&outputFormat=application/json&typeName=ebler_usr&propertyname=adi,id`)
            const ebValues = response.data.features.map(((value: any) => value.properties))
            setEbler(ebValues)

        }
    }
    const getTgbler = async () => {
        const serviceUrl = services.filter(obj => obj.type === 'VECTOR')[0]?.url
        if (serviceUrl) {
            const response = await axios.get(serviceUrl! + `/ows?service=WFS&version=1.0.0&request=getfeature` + (token ? `&token=${token}` : '') + `&outputFormat=application/json&typeName=tgb_usr&propertyname=adi,id`)
            const tgbValues = response.data.features.map(((value: any) => value.properties))
            setTgbler(tgbValues)

        }
    }

    const updateTransaction = async () => {
        setUpdateState(false);
        const feature :any = new Feature();

        feature.setId(selectedFeature.id);
        const layername = selectedFeature.id?.split('.')[0]
        const service = services.find(service => service.layers.find(layer => layer.name === layername));

        if (service) {
            const wfs = new WFS();
            const xml = (wfs.writeTransaction as any)([], [feature], [], { hasZ: true, featureType: featureLayer.name, featurePrefix: service.workspace, featureNS: service.url, srsName: 'EPSG:3857' })
            var xmlText = new XMLSerializer().serializeToString(xml)

            try {
                dispatch(setShowLoading(true));
                const response = await axios.post(`${service.url}/ows?token=${token}`, xmlText, { headers: { 'Content-Type': 'text/plain' } })

                if (response.data.includes('TransactionSummary')) {
                    toast.current.show({ severity: 'success', summary: t('TOAST.Success'), detail: 'Öznitelikler Güncellendi.' });
                    setUpdateState(false);
                    refreshPanel();
                } else {
                    toast.current.show({ severity: 'error', summary: t('TOAST.Unsuccessful'), detail: 'Öznitelikler Güncellenemedi.' });
                }
            } catch (error) {
                console.log(error);
                toast.current.show({ severity: 'error', summary: t('TOAST.Unsuccessful'), detail: 'Öznitelikler Güncellenemedi.' });
            } finally {
                dispatch(setShowLoading(false));
            }
        }
    }

    const refreshPanel = async () => {
        try {
            const selectedFeatureID = selectedFeature.id
            const layername = selectedFeature.id?.split('.')[0]
            const service = services.find(service => service.layers.find(layer => layer.name === layername));

            if (service && service.url) {
                dispatch(setShowLoading(true));
                const featuresResponse: any = await axios(`${service.url}/ows?service=WFS&version=1.0.0&request=getfeature` + (token ? `&token=${token}` : '') + `&typeName=${layername}&maxFeatures=1&outputFormat=application/json&featureID=${selectedFeatureID}`)
                dispatch(setShowLoading(false));
                const feature :any = featuresResponse.data.features[0]
                if (feature) {
                    dispatch(setSelectedFeature(feature))
                }
            }
        } catch (error) {
            dispatch(setShowLoading(false));
            toast.current.show({ severity: 'error', summary: t('TOAST.Error'), detail: t('TOAST.Parcel Information Could Not Refresh') });
        }
    }

    const getDomain = async () => {
        const response = await axios(`${process.env.REACT_APP_BASE_URL}rest/v1/domain/10713/options?token=${token}`)
        setDomain(response.data.options);
    }

    const cancelUpdate = () => {
        setUpdateState(false);
        refreshPanel();
    }


    const formatDate = (value: any) => {
        const date = new Date(value)
        return date.toLocaleDateString('tr-TR', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
        });
    }

    const handleBlur = (value: any, name: string) => {
        if (name === "eposta" && (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value) || value === "")) {
            setProceed(false)
            setEpostaError(true);
            // toast.current.show({ severity: 'error', summary: t('TOAST.Error'), detail: "Hatalı E-posta Adresi. Örnek: example@email.com" });
        }
        else if (name === "eposta" && /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
            setEpostaError(false);
            setProceed(true)
        }
    };

    return (
        <>
            <div>
                {!window.location.href.includes('sb-atlas') && properties && featureLayer && featureLayer.name !== 'osb_sinir_usr' && featureLayer.name !== 'parsel_usr' && featureLayer.name !== 'parsel_pasif_usr' && featureLayer.name !== 'uip_1000' && featureLayer.name !== 'eb_uip_1000' && featureLayer.name !== 'tgb_uip_1000' &&
                    <Dialog header={featureLayer.alias + ' Bilgi Kartı'} className="feature-dialog" visible={true} modal={false} onHide={() => { dispatch(setSelectedFeature(undefined)); dispatch(setFirmResult(null)); setValuesForPlanlar([]); }}>
                        {featureLayer.fields.length < 5 && <div>
                            {featureLayer.fields.map((field: any) => {
                                return <div key={field.id} className="field">
                                    <label>{field.alias}</label>
                                    {(() => {
                                        switch (field.type) {
                                            case 'Integer':
                                                if (field.name === 'il_kodu') {
                                                    return <Dropdown disabled
                                                        options={iller}
                                                        optionLabel='adi'
                                                        optionValue='id'
                                                        value={copyProperties[field.name]}>
                                                    </Dropdown>;
                                                } else if (field.name === 'ilce_kodu') {
                                                    return <Dropdown disabled
                                                        options={ilceler}
                                                        optionLabel='adi'
                                                        optionValue='ilce_kodu'
                                                        value={copyProperties[field.name]}>
                                                    </Dropdown>;
                                                } else {
                                                    return <InputNumber disabled={!updateState} value={copyProperties[field.name]}
                                                        onChange={(e) => changeValue(e.value, field.name)} />;
                                                }
                                            case 'Domain':
                                                return <Dropdown disabled={!updateState}
                                                    options={field.domain}
                                                    optionLabel='desc'
                                                    optionValue='id'
                                                    value={copyProperties[field.name]}
                                                    onChange={(e) => changeValue(e.value, field.name)}>
                                                </Dropdown>;
                                            case 'Date':
                                                return <InputText disabled onChange={(e) => changeValue(e.target.value, field.name)} value={copyProperties[field.name] ? formatDate(copyProperties[field.name]) : ''} />;
                                            case 'CreatedDate':
                                                return <Calendar disabled={!updateState} value={copyProperties[field.name]}
                                                    onChange={(e) => changeValue(e.value, field.name)} />;
                                            case 'Area':
                                                return <InputNumber minFractionDigits={2} maxFractionDigits={2} disabled={!updateState} onChange={(e) => changeValue(e.value, field.name)} value={copyProperties[field.name] ?
                                                    copyProperties[field.name].toFixed(2) :
                                                    undefined} />;
                                            case 'Active':
                                                return <div style={{ paddingTop: '10px' }}>
                                                    <RadioButton checked={copyProperties[field.name]} disabled={!updateState} name="Aktif" onChange={(e) => changeValue(true, field.name)} />
                                                    <label>Aktif</label>
                                                    <RadioButton style={{ marginLeft: '16px' }} disabled={!updateState} checked={!copyProperties[field.name]} name="Pasif" onChange={(e) => changeValue(false, field.name)} />
                                                    <label>Pasif</label>
                                                </div>;
                                            case 'Boolean':
                                                return <div style={{ paddingTop: '10px' }}>
                                                    <RadioButton checked={copyProperties[field.name]} disabled={!updateState} name="Aktif" onChange={(e) => changeValue(true, field.name)} />
                                                    <label>Aktif</label>
                                                    <RadioButton style={{ marginLeft: '16px' }} disabled={!updateState} checked={!copyProperties[field.name]} name="Pasif" onChange={(e) => changeValue(false, field.name)} />
                                                    <label>Pasif</label>
                                                </div>;
                                            case 'Telephone':
                                                if (field.name === 'fax') {
                                                    return
                                                }
                                                return <div style={{ paddingTop: '10px' }}>
                                                    <InputMask
                                                        id="telefon"
                                                        className='phone-info'
                                                        disabled={!updateState}
                                                        mask="0 (999) 999-9999"
                                                        value={copyProperties[field.name]}
                                                        style={{ width: '100% !important' }}

                                                        onChange={(e) => changeValue(e.target.value, 'telefon_no')} />
                                                </div>;
                                            default:
                                                return <InputText disabled={!updateState}
                                                    onBlur={(e) => handleBlur(e.target.value, field.name)}
                                                    onChange={(e) => changeValue(e.target.value, field.name)} value={copyProperties[field.name] ? copyProperties[field.name] : ''} />;
                                        }
                                    })()}
                                </div>;
                            })}
                            {/* {(featureLayer.name !== 'il_usr' || featureLayer.name === 'osb_sinir_usr' ||featureLayer.name !== 'ebler_usr'  ) && properties.parsel_sayisi !== 0 &&
                                <div>
                                    <label>Parsel Doluluk Oranı</label>
                                    <ProgressBar value={((properties.dolu_parsel / properties.parsel_sayisi) * 100).toFixed(2)}></ProgressBar>
                                </div>
                            } */}
                        </div>}

                        {featureLayer.fields.length > 4 && <div style={{ minWidth: '600px' }}>
                            <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'flex-start', justifyContent: 'space-between' }}>
                                <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                                    {featureLayer.fields.filter((field: any) => featureLayer.fields.indexOf(field) < featureLayer.fields.length / 2).map((field: any) => {
                                        return <div key={field.id} className="field">
                                            <label>{field.alias}</label>
                                            {(() => {
                                                switch (field.type) {
                                                    case 'Integer':
                                                        if (field.name === 'il_kodu') {
                                                            return <Dropdown disabled
                                                                options={iller}
                                                                optionLabel='adi'
                                                                optionValue='id'
                                                                value={copyProperties[field.name]}>
                                                            </Dropdown>;
                                                        } else if (field.name === 'ilce_kodu') {
                                                            return <Dropdown disabled={(featureLayer.name !== 'ebler_usr') && !updateState}
                                                                options={ilceler?.filter((ilce: any) => ilce.il_kodu === copyProperties['il_kodu'])}
                                                                optionLabel='adi'
                                                                optionValue='ilce_kodu'
                                                                onChange={(e) => changeValue(e.value, field.name)}
                                                                value={copyProperties[field.name]}>
                                                            </Dropdown>;
                                                        } else {
                                                            return <InputNumber disabled={!updateState} value={copyProperties[field.name]}
                                                                onChange={(e) => changeValue(e.value, field.name)} />;
                                                        }
                                                    case 'Domain':
                                                        return <Dropdown disabled={!updateState}
                                                            options={field.domain}
                                                            optionLabel='desc'
                                                            optionValue='id'
                                                            value={copyProperties[field.name]}
                                                            onChange={(e) => changeValue(e.value, field.name)}>
                                                        </Dropdown>;
                                                    case 'Date':
                                                        return <InputText disabled onChange={(e) => changeValue(e.target.value, field.name)} value={copyProperties[field.name] ? formatDate(copyProperties[field.name]) : ''} />;

                                                    case 'CreatedDate':
                                                        return <Calendar disabled={!updateState} value={copyProperties[field.name]}
                                                            onChange={(e) => changeValue(e.value, field.name)} />;
                                                    case 'Area':
                                                        return <InputNumber minFractionDigits={2} maxFractionDigits={2} disabled={!updateState} onChange={(e) => changeValue(e.value, field.name)} value={copyProperties[field.name] ?
                                                            copyProperties[field.name].toFixed(2) :
                                                            undefined} />;
                                                    case 'Active':
                                                        return <div style={{ paddingTop: '10px' }}>
                                                            <RadioButton checked={copyProperties[field.name]} disabled={!updateState} name="Aktif" onChange={(e) => changeValue(true, field.name)} />
                                                            <label>Aktif</label>
                                                            <RadioButton style={{ marginLeft: '16px' }} disabled={!updateState} checked={!copyProperties[field.name]} name="Pasif" onChange={(e) => changeValue(false, field.name)} />
                                                            <label>Pasif</label>
                                                        </div>;
                                                    case 'Boolean':
                                                        return <div style={{ paddingTop: '10px' }}>
                                                            <RadioButton checked={copyProperties[field.name]} disabled={!updateState} name="Aktif" onChange={(e) => changeValue(true, field.name)} />
                                                            <label>Aktif</label>
                                                            <RadioButton style={{ marginLeft: '16px' }} disabled={!updateState} checked={!copyProperties[field.name]} name="Pasif" onChange={(e) => changeValue(false, field.name)} />
                                                            <label>Pasif</label>
                                                        </div>;
                                                    case 'Telephone':
                                                        return <div style={{ paddingTop: '10px' }}>
                                                            <InputMask
                                                                id="telefon"
                                                                className='phone-info'
                                                                disabled={!updateState}
                                                                mask="0 (999) 999-9999"
                                                                value={copyProperties[field.name]}
                                                                style={{ width: '100% !important' }}
                                                                onChange={(e) => changeValue(e.target.value, 'telefon_no')} />
                                                        </div>;
                                                    default:
                                                        return <InputText maxLength={field.name === 'kep_adresi' ? 50 : 255}
                                                            onInput={(e: any) => {
                                                                if (field.name === 'kep_adresi') {
                                                                    e.target.value = e.target.value.substring(0, 49)
                                                                }
                                                            }}
                                                            disabled={!updateState} onChange={(e) => changeValue(e.target.value, field.name)} value={copyProperties[field.name]} onBlur={(e) =>
                                                                handleBlur(e.target.value, field.name)
                                                            }
                                                        />;
                                                }
                                            })()}
                                        </div>;
                                    })}
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', width: '48%' }}>
                                    {featureLayer.fields.filter((field: any) => featureLayer.fields.indexOf(field) >= featureLayer.fields.length / 2).map((field: any) => {
                                        return <div key={field.id} className="field">
                                            <label>{field.name === "eposta" ? field.alias.concat('*') : field.alias}</label>
                                            {(() => {
                                                switch (field.type) {
                                                    case 'Integer':
                                                        if (field.name === 'il_kodu') {
                                                            return <Dropdown disabled
                                                                options={iller}
                                                                optionLabel='adi'
                                                                optionValue='id'
                                                                value={copyProperties[field.name]}>
                                                            </Dropdown>;
                                                        } else if (field.name === 'ilce_kodu') {
                                                            return <Dropdown disabled
                                                                options={ilceler}
                                                                optionLabel='adi'
                                                                optionValue='ilce_kodu'
                                                                value={copyProperties[field.name]}>
                                                            </Dropdown>;
                                                        } else {
                                                            return <InputNumber disabled={updateState} value={copyProperties[field.name]}
                                                                onChange={(e) => changeValue(e.value, field.name)} />;
                                                        }
                                                    case 'Domain':
                                                        return <Dropdown disabled={!updateState}
                                                            options={field.domain}
                                                            optionLabel='desc'
                                                            optionValue='id'
                                                            value={copyProperties[field.name]}
                                                            onChange={(e) => changeValue(e.value, field.name)}>
                                                        </Dropdown>;
                                                    case 'Date':
                                                        if (field.name === 'resmi_gazete_tarihi') {

                                                            return <Calendar disabled={!updateState} id='date' dateFormat="dd.mm.yy" value={copyProperties[field.name] ? new Date(copyProperties[field.name]) : new Date('')}
                                                                onChange={(e: any) => {
                                                                    changeValue(e.value.toISOString(), field.name)
                                                                    // updatedValue = d.toISOString()
                                                                }
                                                                } />
                                                        } else {
                                                            return <InputText disabled onChange={(e) => changeValue(e.target.value, field.name)} value={copyProperties[field.name] ? formatDate(copyProperties[field.name]) : ''} />;
                                                        }
                                                    case 'CreatedDate':
                                                        return <Calendar disabled={!updateState} value={copyProperties[field.name]}
                                                            onChange={(e) => changeValue(e.value, field.name)} />;
                                                    case 'Area':
                                                        return <InputNumber minFractionDigits={2} maxFractionDigits={2} disabled={!updateState} onChange={(e) => changeValue(e.value, field.name)} value={copyProperties[field.name] ?
                                                            copyProperties[field.name].toFixed(2) :
                                                            undefined} />;
                                                    case 'Active':
                                                        return <div style={{ paddingTop: '10px' }}>
                                                            <RadioButton checked={copyProperties[field.name]} disabled={!updateState} name="Aktif" onChange={(e) => changeValue(true, field.name)} />
                                                            <label>Aktif</label>
                                                            <RadioButton style={{ marginLeft: '16px' }} disabled={!updateState} checked={!copyProperties[field.name]} name="Pasif" onChange={(e) => changeValue(false, field.name)} />
                                                            <label>Pasif</label>
                                                        </div>;
                                                    case 'Boolean':
                                                        return <div style={{ paddingTop: '10px' }}>
                                                            <RadioButton checked={copyProperties[field.name]} disabled={!updateState} name="Aktif" onChange={(e) => changeValue(true, field.name)} />
                                                            <label>Aktif</label>
                                                            <RadioButton style={{ marginLeft: '16px' }} disabled={!updateState} checked={!copyProperties[field.name]} name="Pasif" onChange={(e) => changeValue(false, field.name)} />
                                                            <label>Pasif</label>
                                                        </div>;
                                                    case 'Telephone':
                                                        return <div style={{ paddingTop: '10px' }}>
                                                            <InputMask
                                                                id="telefon"
                                                                className='phone-info'
                                                                mask="0 (999) 999-9999"
                                                                disabled={!updateState}
                                                                value={copyProperties[field.name]}
                                                                style={{ width: '100% !important' }}
                                                                onChange={(e) => changeValue(e.target.value, 'telefon_no')} />
                                                        </div>;
                                                    default:
                                                        return <>
                                                            <InputText
                                                                maxLength={field.name === 'adres' ? 100 : field.name === 'resmi_gazete_sayisi' || field.name === 'resmi_gazete_linki' || field.name === 'yonetici_sirket' ? 50 : 255}
                                                                disabled={!updateState}
                                                                onChange={(e) => changeValue(e.target.value, field.name)}
                                                                value={copyProperties[field.name] ? copyProperties[field.name] : ""}
                                                                onBlur={(e) => handleBlur(e.target.value, field.name)}
                                                            />
                                                            {epostaError && field.name === "eposta" &&
                                                                <div style={{ display: 'flex', alignItems: 'center' }}>
                                                                    <i className='pi pi-info-circle' style={{ marginRight: '0.5em', fontSize: '1rem', color: '#D94B4B' }}></i>
                                                                    <p style={{ color: '#D94B4B', fontSize: '12px' }}>Hatalı E-posta Adresi. Örnek: example@email.com</p>
                                                                </div>
                                                            }
                                                        </>
                                                    //SOCAR TURKEY ENERJİ ANONİM ŞİRKETİ ÖZEL EB
                                                }
                                            })()}
                                        </div>;
                                    })}
                                </div>
                            </div>
                            {/* {(featureLayer.name !== 'il_usr' && featureLayer.name !== 'ebler_usr'  && featureLayer.name !== 'tgb_usr' ) && properties.parsel_sayisi !== 0 &&
                                <div>
                                    <label>Parsel Doluluk Oranı</label>
                                    <ProgressBar value={((properties.dolu_parsel / properties.parsel_sayisi) * 100).toFixed(2).replace('.', ',')}></ProgressBar>
                                </div>} */}
                            {(featureLayer.name === 'ebler_usr' || featureLayer.name === 'tgb_usr') &&
                                <div style={{ marginTop: '15px' }}>
                                    {(!updateState && canUpdate) &&
                                        <Button onClick={() => setUpdateState(true)}>Güncelle</Button>}
                                    {updateState &&
                                        <Button onClick={() => cancelUpdate()}>Güncellemeyi İptal Et</Button>}
                                    {updateState &&
                                        <Button style={{ marginLeft: '25px' }} disabled={!proceed} onClick={() => updateTransaction()}>Kaydet</Button>}
                                </div>}
                        </div>}
                        {
                            selectedFeature
                            && (selectedFeature.id?.split('.')[0] === 'istatistik_bolge_duzey_2_usr'
                                || selectedFeature.id?.split('.')[0] === 'cografi_bolge_usr'
                                || selectedFeature.id?.split('.')[0] === 'tesvik_bolgeleri_usr') &&
                            <div style={{ display: 'flex', flexDirection: 'column' }}>
                                <label style={{ margin: '0.5em 0.2em' }} htmlFor='field'>Osb Sayısı</label>
                                <InputText disabled autoComplete='off' id={osbSayisi} value={osbSayisi} maxLength={250} />
                            </div>
                        }

                    </Dialog>}
                {valuesForPlanlar && valuesForPlanlar.length > 0 && !window.location.href.includes('sb-atlas') &&
                    <Dialog header={' Bilgi Kartı'} className="feature-dialog" visible={true} modal={false} onHide={() => { dispatch(setHighlightAll(undefined)); dispatch(setSelectedFeature(undefined)); dispatch(setFirmResult(null)); setValuesForPlanlar([]); }}>
                        {
                            valuesForPlanlar.map((value: any) =>
                                <div style={{ display: 'flex', flexDirection: 'column' }}>
                                    <label style={{ margin: '0.5em 0.2em' }} htmlFor='field'>{value.key} </label>
                                    <InputText disabled autoComplete='off' id={value.alias} value={value.value} maxLength={250} />
                                </div>
                            )
                        }
                    </Dialog>
                }
                {properties && featureLayer && featureLayer.name === 'osb_sinir_usr' &&
                    <OsbInfo fields={properties} layer={featureLayer} feature={selectedFeature}></OsbInfo>}
                {properties && featureLayer && (featureLayer.name === 'parsel_usr' || featureLayer.name === 'parsel_pasif_usr') &&
                    <ParselInfo feature={selectedFeature} fields={properties} layerInfo={featureLayer}></ParselInfo>}
                {selectedFeature && selectedFeature.get && selectedFeature.get('tkgm') &&
                    <TkgmParsel></TkgmParsel>}
            </div><Toast ref={toast} /></>
    )
}
